import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink, Redirect, Switch, Route, withRouter } from 'react-router-dom'
import CustomButton from '../shared/CustomButton'
import InvoiceRoute from './InvoiceRoute'
import InvoiceItemContainer from './InvoiceItemContainer'
import InvoiceForm from './InvoiceForm'
import InvoiceSearch from './InvoiceSearch'
import { InvoiceService } from '../../../services'
import { startFetch, endFetch } from '../../../actions/generalActions'
import { prefix } from '../../../i18n'

const tInvoice = prefix('invoice')

class UserContainer extends Component {
  state = {
    createdInvoices: [],
    toApproveInvoices: [],
    registeredInvoices: [],
    createdPage: 1,
    createdTotalPages: null,
    toApprovePage: 1,
    toApproveTotalPages: null,
    registeredPage: 1,
    registeredTotalPages: null,
    errors: {},
    saleTypes: [],
  }

  componentDidMount() {
    const { campaign } = this.props
    this.fetchCreated(campaign, 1)
    this.fetchToApprove(campaign, 1)
    this.fetchRegistered(campaign, 1)
    this.fetchSaleTypes(campaign)
  }

  fetchCreated = (campaign, page) => {
    const { client } = this.props
    this.props.startFetch()
    InvoiceService.getCreatedInvoices({ clientId: client.slug, campaignId: campaign.slug, page })
      .then(response => {
        const { invoices, total_pages } = response.data
        this.setState({ createdInvoices: invoices, createdTotalPages: total_pages, createdPage: page })
        this.props.endFetch()
      })
      .catch(() => this.props.endFetch())
  }

  fetchToApprove = (campaign, page) => {
    const { client } = this.props
    this.props.startFetch()
    InvoiceService.getToApproveInvoices({ clientId: client.slug, campaignId: campaign.slug, page })
      .then(response => {
        const { invoices, total_pages } = response.data
        this.setState({ toApproveInvoices: invoices, toApproveTotalPages: total_pages, toApprovePage: page })
        this.props.endFetch()
      })
      .catch(() => this.props.endFetch())
  }

  fetchRegistered = (campaign, page) => {
    const { client } = this.props
    this.props.startFetch()
    // Service method is "getRegistredInvoices" (original typo preserved in the service).
    InvoiceService.getRegistredInvoices({ clientId: client.slug, campaignId: campaign.slug, page })
      .then(response => {
        const { invoices, total_pages } = response.data
        this.setState({ registeredInvoices: invoices, registeredTotalPages: total_pages, registeredPage: page })
        this.props.endFetch()
      })
      .catch(() => this.props.endFetch())
  }

  fetchSaleTypes = (campaign) => {
    const { client } = this.props
    InvoiceService.getSaleTypes({ clientId: client.slug, campaignId: campaign.slug })
      .then(response => this.setState({ saleTypes: response.data.sale_types || [] }))
      .catch(() => {})
  }

  handleInvoiceCreation = ({ number, invoiceDate, saleType, document, products }) => {
    const { campaign, client } = this.props
    this.props.startFetch()
    InvoiceService.addInvoiceHeader({
      clientId: client.slug,
      campaignId: campaign.slug,
      number,
      invoiceDate,
      saleType,
      document: document || {},
      name: (document && document.name) || '',
      products: products || [],
    })
      .then(() => {
        this.fetchCreated(campaign, 1)
        this.props.endFetch()
        this.setState({ errors: {} })
        this.props.history.push('/invoice/created')
      })
      .catch(error => {
        this.props.endFetch()
        if (error.response && error.response.data) {
          this.setState({ errors: error.response.data })
        }
      })
  }

  handleSearchRequest = (filters) => {
    const { campaign, client } = this.props
    this.props.startFetch()
    // There is no dedicated search endpoint; filter the created invoices list.
    InvoiceService.getCreatedInvoices({
      clientId: client.slug,
      campaignId: campaign.slug,
      filters,
      page: 1,
    })
      .then(response => {
        const { invoices } = response.data
        this.setState({ createdInvoices: invoices, toApproveInvoices: [], registeredInvoices: [] })
        this.props.endFetch()
      })
      .catch(() => this.props.endFetch())
  }

  handleClientPageUpdate = (path) => ({ selected }) => {
    const { campaign } = this.props
    const page = selected + 1
    if (path.includes('created'))     this.fetchCreated(campaign, page)
    if (path.includes('to_approve'))  this.fetchToApprove(campaign, page)
    if (path.includes('registered'))  this.fetchRegistered(campaign, page)
  }

  render() {
    const { campaign } = this.props
    const {
      createdInvoices, toApproveInvoices, registeredInvoices,
      createdPage, createdTotalPages,
      toApprovePage, toApproveTotalPages,
      registeredPage, registeredTotalPages,
      errors, saleTypes,
    } = this.state

    const tabs = [
      { label: tInvoice('created'), path: '/invoice/created' },
      { label: tInvoice('to-approve'), path: '/invoice/to_approve' },
      { label: tInvoice('registered'), path: '/invoice/registered' },
    ]

    return (
      <Switch>
        {/* ── Inline new-invoice page ── */}
        <Route exact path="/invoice/new"
          render={() => (
            <InvoiceForm
              onSubmit={this.handleInvoiceCreation}
              campaign={campaign}
              client={this.props.client}
              errors={errors}
              saleTypes={saleTypes}
            />
          )}
        />

        {/* ── Invoice detail pages: no outer chrome ── */}
        <Route path="/invoice/created/:id" render={() => (
          <InvoiceItemContainer editable linking="/invoice/created" campaign={campaign} client={this.props.client} />
        )} />
        <Route path="/invoice/to_approve/:id" render={() => (
          <InvoiceItemContainer editable={false} linking="/invoice/to_approve" campaign={campaign} client={this.props.client} />
        )} />
        <Route path="/invoice/registered/:id" render={() => (
          <InvoiceItemContainer editable={false} linking="/invoice/registered" campaign={campaign} client={this.props.client} />
        )} />

        {/* ── List / detail views ── */}
        <Route render={() => (
          <div className="invoice-layout">
            <div className="invoice-layout-header">
              <h4 className="invoice-layout-header-title">{tInvoice('title')}</h4>
            </div>

            <nav className="invoice-layout-navigation">
              {tabs.map(tab => (
                <NavLink
                  key={tab.path}
                  to={tab.path}
                  activeClassName="invoice-layout-navigation-item-active"
                  className="invoice-layout-navigation-item"
                >
                  {tab.label}
                </NavLink>
              ))}
              <div className="invoice-layout-navigation-add">
                <NavLink to="/invoice/new" className="gl-button secondary medium body-m">
                  {tInvoice('add')}
                </NavLink>
              </div>
            </nav>

            <InvoiceSearch
              campaign={campaign}
              onSearchRequest={this.handleSearchRequest}
            />

            <div className="invoice-layout-content">
              {/* Default tab: redirect bare /invoice to /invoice/created */}
              <Switch>
                <Route exact path="/invoice">
                  <Redirect to="/invoice/created" />
                </Route>
              </Switch>

              <InvoiceRoute
                path="/invoice/created"
                editable
                validatable={false}
                completeTable={false}
                completeForm={false}
                validatorView={false}
                campaign={campaign}
                client={this.props.client}
                invoices={createdInvoices}
                onPageChange={this.handleClientPageUpdate}
                currentPage={createdPage - 1}
                totalPages={createdTotalPages}
              />
              <InvoiceRoute
                path="/invoice/to_approve"
                editable={false}
                validatable={false}
                completeTable={false}
                completeForm={false}
                validatorView={false}
                campaign={campaign}
                client={this.props.client}
                invoices={toApproveInvoices}
                onPageChange={this.handleClientPageUpdate}
                currentPage={toApprovePage - 1}
                totalPages={toApproveTotalPages}
              />
              <InvoiceRoute
                path="/invoice/registered"
                editable={false}
                validatable={false}
                completeTable
                completeForm
                validatorView={false}
                campaign={campaign}
                client={this.props.client}
                invoices={registeredInvoices}
                onPageChange={this.handleClientPageUpdate}
                currentPage={registeredPage - 1}
                totalPages={registeredTotalPages}
              />
            </div>
          </div>
        )} />
      </Switch>
    )
  }
}

const mapStateToProps = (state) => ({
  client: state.userReducer.client,
  campaignUser: state.balanceReducer.campaignUser,
})

const mapDispatchToProps = (dispatch) => ({
  startFetch: () => dispatch(startFetch()),
  endFetch: () => dispatch(endFetch()),
})

// withRouter MUST wrap connect() so that URL changes inject a new `location`
// ownProp, forcing connect()'s shouldComponentUpdate to return true and
// re-render the InvoiceRoute children against the updated location.
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserContainer))
